
export const baseApiUrl = 'https://oralsantahelena.intelite.com.br/api/'
// export const baseApiUrl = 'http://localhost:3002/api/'
export const userKey = '__orale_user'
export const modelBoleto = {
    pagadorDocumentoTipo: 1,
    pagadorDocumentoNumero: '',
    pagadorNome: '',
    pagadorEndereco: '',
    pagadorBairro: '',
    pagadorCidade: '',
    pagadorUf: '',
    pagadorCep: '',
    dataVencimento: '',
    valorNominal: 0,
    multaPercentual: 0,
    multaQuantidadeDias: 0,
    jurosPercentual: 0,
    tipoDesconto: 0,
    descontoValor: 0,
    descontoDataLimite: '',
    valorAbatimento: 0,
    tipoProtesto: 0,
    protestoQuantidadeDias: 0,
    baixaQuantidadeDias: 0,
    mensagem: '',
    tipoTitulo: 4,
    nsu: '',
    nossoNumero: 0,
    seuNumero: '',
    // convenioId: '8a7ab620-ca84-459d-804b-05955691f4ee'
    // convenioId: '81f402e3-ca3b-4f5b-9614-68109704cf9a'
    convenioId: '81ae5518-3c16-4b45-962d-0150f9893a79'
}

export default { baseApiUrl, modelBoleto }